/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Activatetrial1Inputs */

const en_activatetrial1 = /** @type {(inputs: Activatetrial1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Activate Trial`)
};

const de_activatetrial1 = /** @type {(inputs: Activatetrial1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Testabo aktivieren`)
};

/**
* | output |
* | --- |
* | "Activate Trial" |
*
* @param {Activatetrial1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const activatetrial1 = /** @type {((inputs?: Activatetrial1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Activatetrial1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_activatetrial1(inputs)
	return de_activatetrial1(inputs)
});
export { activatetrial1 as "activateTrial" }